export default "__VITE_ASSET__DiTNDzwW__"